import React from "react";
import styled, { css } from "styled-components";

import Text from "components/ui/Text";
import { theme } from "styles";

const TERMS_TEXT = [
  {
    title: "1. 개인정보 수집, 보유 및 이용기간",
    contents: [
      {
        num: "0",
        text: `회사는 바디코디 서비스 제공을 위하여 다음과 같은 개인정보를 필수 정보로 수집 및 이용합니다.`,
      },
    ],
  },
  {
    title: "2. 개인정보 처리 위탁 현황",
    contents: [
      {
        num: "1",
        text: `회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리 업무를 위탁할 수 있습니다.`,
      },
      {
        num: "2",
        text: `회사는 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적.관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리.감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.`,
      },
      {
        num: "3",
        text: `위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.`,
      },
      {
        num: "4",
        text: `개인정보 보호법 제 17조에 따라 아래와 같은 사항을 안내하고 동의를 받아 귀하의 개인정보를 수탁업체에게 공유합니다.`,
      },
      {
        num: "5",
        text: `수탁자에 공유되는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다. 또한 이용자의 서비스 요청에 따라 해당하는 업체에 선택적으로 개인정보가 제공되고 있습니다.`,
      },
      {
        num: "6",
        text: `위탁 업체 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있으며 변경 시 서비스의 공지사항을 통해 사전 공지합니다.`,
      },
      {
        num: "7",
        text: `단기 이벤트의 경우, 매 이벤트 참여시에 개별 공지됩니다.`,
      },
    ],
  },
];

const TermsPrivacyAgree = ({ header = true, type, onClose }) => {
  return (
    <Wrapper>
      {header && (
        <Header>
          <Text fontSize="18px" lineHeight="24px">
            개인정보 수집 및 이용동의
          </Text>
          <Text lineHeight="24px" onClick={onClose}>
            닫기
          </Text>
        </Header>
      )}
      <Main>
        <Text
          color="gray80"
          fontSize="14px"
          lineHeight="24px"
          css={css`
            margin-bottom: 16px;
          `}
        >
          (주) 레드블루는 아래의 목적으로 개인정보를 수집 및 이용하며, 이용자의
          개인정보를 안전하게 취급하는데 최선을 다하고 있습니다.
        </Text>

        {TERMS_TEXT.map((v) => {
          return (
            <TextWrapper key={v.title}>
              <Text
                color="gray80"
                fontSize="16px"
                fontWeight="700"
                lineHeight="24px"
                css={css`
                  margin-bottom: 8px;
                `}
              >
                {v.title}
              </Text>
              {v.contents.map((c, i) => {
                if (c.num === "0") {
                  return (
                    <>
                      {" "}
                      <TextBox key={i}>
                        {c.num !== "0" && (
                          <Text
                            color="gray80"
                            fontSize="14px"
                            lineHeight="24px"
                          >
                            {c.num}.
                          </Text>
                        )}
                        <Text color="gray80" fontSize="14px" lineHeight="24px">
                          {c.text}
                        </Text>
                      </TextBox>
                      <TableWrapper>
                        <table>
                          <tr>
                            <th>수집항목</th>
                            <th>수집목적</th>
                            <th>보유·이용기간</th>
                          </tr>
                          <tr>
                            <td>
                              아이디, 비밀번호, 이메일, 이름, 성별, 생년,
                              휴대전화번호, 이용기기정보
                            </td>
                            <td>
                              이용자가 제공한 정보를 기반으로 연동 센터를
                              추천하고, 연동된 센터의 회원정보와의 매칭,
                              피트니스 서비스의 스케쥴 예약, 구매, 내 운동기록
                              관리, 커뮤니티 등의 서비스 기능 제공을 위해
                              개인정보를 수집합니다.
                            </td>
                            <td rowSpan={2}>
                              수집된 정보는 회원탈퇴 시 또는 서비스 이용 동의
                              철회 시 등 개인정보 수집 및 이용 목적이 달성된
                              후에는 지체없이 파기됩니다. 단, 관계법령의 규정에
                              의하여 수집 및 이용 목적 달성 후에도 일정 기간
                              계속하여 보존할 필요가 있는 경우, 회사는 해당 기간
                              동안 개인정보를 보관합니다.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              서비스 이용 또는 업무처리 과정에서 자동으로
                              생성되어 수집되는 정보-접속IP 정보, 서비스 이용
                              기록(로그데이터, 쿠키, 이용시간 등) 등
                            </td>
                            <td>
                              인구통계학적 분석, 서비스 방문 및 이용기록의 분석,
                              건강관리 및 의료 서비스 연구, 교육용 분석,
                              개인정보 및 건강정보에 기반한 맞춤형 개인 서비스
                              개발 및 제공 등 서비스 이용 기록, 접속 빈도 및
                              서비스 이용에 대한 통계, 프라이버시 보호 측면의
                              서비스 환경 구축, 맞춤형 서비스 제공, 서비스
                              개선에 활용
                            </td>
                          </tr>
                        </table>
                      </TableWrapper>
                    </>
                  );
                }
                if (c.num === "4") {
                  return (
                    <>
                      {" "}
                      <TextBox key={i}>
                        {c.num !== "0" && (
                          <Text
                            color="gray80"
                            fontSize="14px"
                            lineHeight="24px"
                          >
                            {c.num}.
                          </Text>
                        )}
                        <Text color="gray80" fontSize="14px" lineHeight="24px">
                          {c.text}
                        </Text>
                      </TextBox>
                      <TableWrapper>
                        <table>
                          <tr>
                            <th>수탁업체</th>
                            <th>제공목적 및 내용</th>
                            <th>보유·이용기간</th>
                          </tr>
                          <tr>
                            <td>토스페이먼츠</td>
                            <td>결제서비스 제공</td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                          <tr>
                            <td>(주)알리는사람들</td>
                            <td>기기인증 및 사용자 인증용 문자전송</td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                          <tr>
                            <td>모두싸인</td>
                            <td>
                              가맹점과 회원간 전자계약 및 전자계약 서명 시
                            </td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                          <tr>
                            <td>네이버파이낸셜(주)</td>
                            <td>결제 서비스 제공</td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                          <tr>
                            <td>네이버클라우드(주)</td>
                            <td>기기인증 및 사용자인증용 문자전송</td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                          <tr>
                            <td>(주)슈프리마</td>
                            <td>회원의 가맹점 출입제어</td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                          <tr>
                            <td>(주)케이에스넷</td>
                            <td>가맹점과 회원간 카드결제</td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                          <tr>
                            <td>(주)헥토파이낸셜</td>
                            <td>결제 서비스 제공</td>
                            <td>회원 탈퇴 시 혹은 위탁계약 종료시까지</td>
                          </tr>
                        </table>
                      </TableWrapper>
                    </>
                  );
                }
                return (
                  <TextBox key={i}>
                    {c.num !== "0" && (
                      <Text color="gray80" fontSize="14px" lineHeight="24px">
                        {c.num}.
                      </Text>
                    )}
                    <Text color="gray80" fontSize="14px" lineHeight="24px">
                      {c.text}
                    </Text>
                  </TextBox>
                );
              })}
            </TextWrapper>
          );
        })}
        <Text
          color="gray80"
          fontSize="14px"
          lineHeight="24px"
          css={css`
            margin-bottom: 16px;
          `}
        >
          본 정보 제공에 동의하지 않을 수 있으며, 동의하지 않은 경우 서비스
          이용이 제한됩니다.
        </Text>
        <Text
          color="gray80"
          fontSize="14px"
          lineHeight="24px"
          css={css`
            margin-bottom: 16px;
          `}
        >
          더 자세한 사항은 개인정보처리방침을 참고하시기 바랍니다.
        </Text>
      </Main>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100% !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 0 24px 56px !important;
  overflow-y: auto;
`;

const Header = styled.div`
  padding: 14px 0;
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  span:last-of-type {
    position: absolute;
    right: 0;
  }
`;

const Main = styled.div``;
const TableWrapper = styled.div`
  width: auto;
  overflow-x: scroll;
  table {
    width: 160%;
  }
  td {
    padding: 4px;
  }
  table,
  td,
  th {
    border: 1px solid #cccccc;
    border-collapse: collapse;
    color: ${theme.colors["gray80"]};
    font-size: 14px;
    font-weight: 400;
  }
`;
const TextWrapper = styled.div`
  margin-bottom: 16px;
`;

const TextBox = styled.div`
  display: flex;
  span:first-child {
    margin-right: 4px;
  }
  span:last-child {
    white-space: pre-line;
  }
`;
export default TermsPrivacyAgree;
